import { FC } from 'react';
import type { RowProps } from '../Row';
import Row from '../Row';

interface CalloutFooterProps extends RowProps {}

const CalloutFooter: FC<CalloutFooterProps> = ({ children, ...props }) => {
    return (
        <Row justifyContent="center" alignItems="center" {...props}>
            {children}
        </Row>
    );
};

export type { CalloutFooterProps };
export default CalloutFooter;
